module["exports"] = [
  "074## ######",
  "075## ######",
  "076## ######",
  "077## ######",
  "078## ######",
  "079## ######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/cell_phone/formats.js
// module id = 1697
// module chunks = 0